<template>
  <card :id="Id" :title="(!this.translationExists('pages.DeviceDetails.' + type)
    ? type
    : this.$t('pages.DeviceDetails.' + type)
  ).concat(' ', title)
    " :styles="''" :icon="{ class: 'scf-vector', styles: 'padding:5px;' }" :enableCollapse="true" :withBody="true"
    :isCollapsed="true" :fullScreen="false">
    <template v-slot:card-edit>
      <button class="btn btn-sm save-button ml-2" @click.prevent="UpdateParameters"
        v-show="Object.keys(this.modifiedParams).length > 0">
        <i class="scf-save" />
        {{ $t('common.save') }}
      </button>
    </template>

    <template v-slot:card-drop-down>
    </template>

    <template v-slot:card-body-title> </template>

    <template v-slot:card-body-container>
      <div class="card-body">
        <div class="row">
          <div :class="items.length == 1
            ? 'col-md-12'
            : items.length == 2
              ? 'col-md-6'
              : 'col-md-4'
            " style="padding-top: 10px" v-for="(item, index) in items" v-bind:key="index">
            <card-info :Id="item.Index" :title="this.GetTraductionForPrincipalCardTitle(item.Key)"
              :items="GetCustomDetails(item.Parameters)" :type="item.Type" :classCSS="item.Icon" :Collapsed="true"
              :isCollapsed="true" @eventemit="showdatafromchildAssociatedDevice"></card-info>
          </div>
        </div>
        <!--  Start lifeCycleInfos  -->
        <!-- <div class="row"  v-if="hasLifeCycleInfos">  
                    <div class="col-md-12" style="padding-top: 10px">
                  <card-info
                    :Id="960"
                    :title="this.GetTraductionForAdditionalCardTitle(this.LifeCycleInfos.Key)"
                    :items="GetCustomDetails(this.LifeCycleInfos.Parameters)"
                    :type="this.LifeCycleInfos.Type"
                    :classCSS="this.LifeCycleInfos.Icon"
                    :Collapsed="false"
                  ></card-info>
                    </div>
                </div> -->
        <!--  End lifeCycleInfos  -->
        <!-- pairing history                  --------------------------------------------------------------------- -->
        <div class="row" v-if="hasPairingHistory">
          <div class="col-md-12" style="padding-top: 10px">
            <card :id="300" :bgColor="'#FFFFFF'" :title="this.GetTraductionForAdditionalCardTitle('PairingHistory')
              " :styles="'small'" :icon="{
                class: 'scf-additional-params',
                styles: 'padding:5px;',
              }" :enableCollapse="true" :isCollapsed="true" :fullScreen="false">
              <template v-slot:card-edit> </template>

              <template v-slot:card-drop-down> </template>

              <template v-slot:card-body-title> </template>

              <template v-slot:card-body-container>
                <div class="card-body">
                  <div class="row row-padding-bottom-10">
                    <OdataFlexGrid :Api="{
                      base: urlOdata + 'api/v1/OData/',
                      controller: 'devicePairings?deviceId=' + Id,
                    }" :requestHeaders="gridHeaders" :FiltersDefinition="FiltersDefinitionPairing" :ColumnsDefinition="columnsPairing"
                      :FilterColumns="[
                        'Id',
                        'TransmitterId',
                        'TransmitterIdentifier',
                        'TransmitterAlternateIdentifier',
                        'TransmitterRadioMode',
                        'ElectronicIndex',
                        'MechanicalIndex',
                        'PulseWeight',
                        'MountingDate',
                        'Source',
                      ]" :GridHeight="'250px'" :displayLang="culture" v-on:initializedGrid="gridPairingInitialized"
                      v-on:gridFilterChanged="gridPairingFilterChanged"
                      :GridId="'pairingHistoryAttachedDeviceMaindCard-v2'" :ExportsButtons="{
                        Id: 102,
                        Header: ExportsHeader,
                        DataSource: ExportsDataSourcePairing,
                        Events: ExportsEventsPairing,
                      }" :WijmoLicense="config.value('VUE_APP_WIJMO_LICENCE')"
                      v-on:format-columns="formatColumnsPairing" />
                  </div>
                </div>
              </template>
              <template v-slot:card-footer> </template>
            </card>
          </div>
        </div>
        <!--  fin pairing history ################################# -->
        <!-- association history                  --------------------------------------------------------------------- -->
        <div class="row" v-if="hasAssociationHistory">
          <div class="col-md-12" style="padding-top: 10px">
            <card :id="this.identifier" :bgColor="'#FFFFFF'" :title="this.GetTraductionForAdditionalCardTitle('AssociationHistory')
              " :styles="'small'" :icon="{
                class: 'scf-additional-params',
                styles: 'padding:5px;',
              }" :enableCollapse="true" :fullScreen="false">
              <template v-slot:card-edit> </template>

              <template v-slot:card-drop-down> </template>

              <template v-slot:card-body-title> </template>

              <template v-slot:card-body-container>
                <div class="card-body">
                  <div class="row row-padding-bottom-10">
                    <OdataFlexGrid :key="this.Id" :Api="{
                      base: urlOdata + 'api/v1/OData/',
                      controller: `DeviceAssociations?deviceId=${Id}&type=${type}`,
                    }" :requestHeaders="gridHeaders" :FiltersDefinition="FiltersDefinitionAssociation" :ColumnsDefinition="columnsAssociation"
                      :FilterColumns="[
                        'Id',
                        'ServicePointId',
                        'ServicePointIdentifier',
                        'TransmitterId',
                        'TransmitterIdentifier',
                        'TransmitterAlternateIdentifier',
                        'TransmitterInstallingDate',
                        'TransmitterUninstallingDate',
                        'SensorId',
                        'SensorIdentifier',
                        'SensorInstallDate',
                        'SensorUninstallDate',
                        'CreatedDate',
                      ]" :GridHeight="'250px'" :displayLang="culture"
                      v-on:gridFilterChanged="gridAssociationFilterChanged" :GridId="'AssociationHistoryMaindCard-v5'"
                      :ExportsButtons="{
                        Id: this.Id,
                        Header: ExportsHeaderAssociation,
                        DataSource: ExportsDataSourceAssociation,
                        Events: ExportsEventsAssociation,
                      }" :WijmoLicense="config.value('VUE_APP_WIJMO_LICENCE')"
                      v-on:format-columns="formatColumnsAssociation" />
                  </div>
                </div>
              </template>
              <template v-slot:card-footer> </template>
            </card>
          </div>
        </div>

        <!-- Additionnal parameters                  --------------------------------------------------------------------- -->
        <div class="row" v-if="hasUnclassifiedParameters">
          <div class="col-md-12" style="padding-top: 10px">
            <card :id="200" :bgColor="'#FFFFFF'" :title="this.GetTraductionForAdditionalCardTitle(
              'UnclassifiedParameters'
            )
              " :styles="'small'" :icon="{
                class: 'scf-additional-params',
                styles: 'padding:5px;',
              }" :isCollapsed="true" :enableCollapse="true" :fullScreen="false">
              <template v-slot:card-edit> </template>

              <template v-slot:card-drop-down> </template>

              <template v-slot:card-body-title> </template>

              <template v-slot:card-body-container>
                <div class="card-body">
                  <div class="row row-padding-bottom-10">
                    <AdditionalDataGrid :rawData="additionalData" />
                  </div>
                </div>
              </template>
              <template v-slot:card-footer> </template>
            </card>
          </div>
        </div>
        <!--  fin additionnal parameters ################################# -->
      </div>
    </template>
    <template v-slot:card-footer> </template>
  </card>

  <wj-popup style="width: 20%" class="wj-popup" role="dialog" :initialized="initCountRowsPopup">
    <div class="modal-header wj-dialog-header header-countRowsPopup">
      <h5>
        {{ this.$t("pages.DeviceDetails.PairingHistory.TitleCountRows") }}
      </h5>
    </div>
    <div class="modal-body wj-dialog-body body-countRowsPopup">
      <p>{{ this.showCountRowsMessage }}</p>
    </div>
    <div class="modal-footer wj-dialog-footer footer-countRowsPopup">
      <button class="btn btn-primary wj-btn, wj-hide-ok button-countRowsPopup">
        OK
      </button>
    </div>
  </wj-popup>
  <!-- <firmware-list></firmware-list> -->
</template>

<script>
import { computed } from "vue";
import Swal from "sweetalert2";
import Configs from "../../configs";
import CardInfo from "../components/Card.vue";
import { WjPopup } from "@grapecity/wijmo.vue2.input";
import glyphDown from "../assets/icons/wj-glyph-down.svg";
import { Globalize } from "@grapecity/wijmo";
import * as wijmo from "@grapecity/wijmo";
import OdataFlexGrid from "@supervision/vue-components/components/OdataFlexGrid.vue";
// import * as wjcGridXlsx from "@grapecity/wijmo.grid.xlsx";
import utils from "../Utils/libraries";
import MainService from "../services/MainService";
import XlsExport from "../Utils/xls-export.js";
import card from "@supervision/vue-components/components/Card.vue";
import AdditionalDataGrid from "@/components/atoms/AdditionalDataGrid.vue";

export default {
  name: "MainCard",
  inject: ["accessToken", "currentScope"],
  components: {
    CardInfo,
    WjPopup,
    OdataFlexGrid,
    card,
    AdditionalDataGrid,
  },
  watch: {
    currentScope: {
      handler: function (newVal) {
        if (newVal) {
          this.currentScopeView = newVal;
          this.mainService = new MainService(this.$jwt.token, newVal);
        }
      },
      deep: true,
    },
    accessToken(newVal) {
      if (newVal) {
        this.mainService = new MainService(newVal, this.currentScopeView);
      }
    },
  },
  props: {
    Id: {
      type: Number,
      required: false,
      default: 0,
    },
    type: {
      type: String,
      required: true,
    },
    identifier: {
      type: String,
      required: true,
    },
    dataModel: {
      type: [String, Object],
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
    LifeCycleInfos: {
      type: Object,
      required: false,
    },
    hasUnclassifiedParameters: {
      type: Boolean,
      required: true,
    },
    hasPairingHistory: {
      type: Boolean,
      required: true,
    },
    hasAssociationHistory: {
      type: Boolean,
      required: true,
    },
    ErrorMessages: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      gridHeaders: {
        authorization: `bearer ${this.accessToken}`,
        'X-Current-Scope': computed(() => this.isPreselectedScope ? this.preselectedScope : this.currentScopeView),
        'X-Custom-Filters': computed(() => this.headerFilters),
      },
      currentScopeView: null,
      config: Configs,
      urlOdata: Configs.value("VUE_APP_WEBAPI"),
      mainService: new MainService(this.$jwt.token, this.currentScopeView),
      showCountRowsMessage: "",
      GridAssociaition: null,
      culture: computed(() => this.$i18n.locale),
      LifeCycleInfosCard: null,
      FiltersDefinitionAssociation: [
        {
          binding: "Id",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "ServicePointId",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "ServicePointIdentifier",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "TransmitterId",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "TransmitterIdentifier",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "TransmitterAlternateIdentifier",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "TransmitterInstallingDate",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "TransmitterUninstallingDate",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "SensorId",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "SensorIdentifier",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "SensorInstallDate",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "SensorUninstallDate",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "CreatedDate",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
      ],

      ExportsHeaderAssociation: {
        text: "Exports",
        icon: "scf-export",
      },

      ExportsDataSourceAssociation: [
        {
          text: "Export as Csv",
          method: "exportCsvAssociation",
          icon: "scf-csv",
        },
        {
          text: "Export as Excel",
          method: "exportExcelAssociation",
          icon: "scf-excel",
        },
      ],

      ExportsEventsAssociation: {
        exportCsvAssociation: this.exportCsvAssociation,
        exportExcelAssociation: this.exportExcelAssociation,
      },

      columnsAssociation: [
        {
          binding: "Id",
          width: "*",
          header: computed(() =>
            this.$t("pages.DeviceDetails.AssociationHistory.columns.Id")
          ),
          visible: false,
          isTechnicalColumn: true,
        },
        {
          binding: "ServicePointId",
          width: "*",

          header: computed(() =>
            this.$t(
              "pages.DeviceDetails.AssociationHistory.columns.ServicePointId"
            )
          ),
          visible: false,
          isTechnicalColumn: true,
        },
        {
          binding: "ServicePointIdentifier",
          width: "*",

          header: computed(() =>
            this.$t(
              "pages.DeviceDetails.AssociationHistory.columns.ServicePointIdentifier"
            )
          ),
        },
        {
          binding: "TransmitterId",
          width: "*",

          header: computed(() =>
            this.$t(
              "pages.DeviceDetails.AssociationHistory.columns.TransmitterId"
            )
          ),
          visible: false,
          isTechnicalColumn: true,
        },
        {
          binding: "TransmitterIdentifier",
          width: "*",

          header: computed(() =>
            this.$t(
              "pages.DeviceDetails.AssociationHistory.columns.TransmitterIdentifier"
            )
          ),
        },
        {
          binding: "TransmitterAlternateIdentifier",
          width: "*",
          header: computed(() =>
            this.$t(
              "pages.DeviceDetails.AssociationHistory.columns.TransmitterAlternateIdentifier"
            )
          ),
        },
        {
          binding: "TransmitterInstallingDate",
          width: "*",
          dataType: 4,
          header: computed(() =>
            this.$t(
              "pages.DeviceDetails.AssociationHistory.columns.TransmitterInstallingDate"
            )
          ),
        },
        {
          binding: "TransmitterUninstallingDate",
          width: "*",
          dataType: 4,
          header: computed(() =>
            this.$t(
              "pages.DeviceDetails.AssociationHistory.columns.TransmitterUninstallingDate"
            )
          ),
        },
        {
          binding: "SensorId",
          width: "*",
          header: computed(() =>
            this.$t("pages.DeviceDetails.AssociationHistory.columns.SensorId")
          ),
          visible: false,
          isTechnicalColumn: true,
        },
        {
          binding: "SensorIdentifier",
          width: "*",
          header: computed(() =>
            this.$t(
              "pages.DeviceDetails.AssociationHistory.columns.SensorIdentifier"
            )
          ),
        },
        {
          binding: "SensorInstallDate",
          width: "*",
          dataType: 4,
          header: computed(() =>
            this.$t(
              "pages.DeviceDetails.AssociationHistory.columns.SensorInstallDate"
            )
          ),
        },
        {
          binding: "SensorUninstallDate",
          width: "*",
          dataType: 4,
          header: computed(() =>
            this.$t(
              "pages.DeviceDetails.AssociationHistory.columns.SensorUninstallDate"
            )
          ),
        },
        {
          binding: "CreatedDate",
          width: "*",
          dataType: 4,
          header: computed(() =>
            this.$t(
              "pages.DeviceDetails.AssociationHistory.columns.CreatedDate"
            )
          ),
        },
        {
          header: "Actions",
          width: "*",
        },
      ],

      columnsAdditionalData: [
        //Define how your columns should look like
        {
          binding: "Label",
          width: "*",
          header: "Label",
          isReadOnly: true,
        },
        {
          binding: "Value",
          width: "*",
          header: "Value",
          isReadOnly: true,
        },
        {
          binding: "HexadecimalAdress",
          width: "*",
          header: "HexadecimalAdress",
          isReadOnly: true,
        },
        {
          binding: "Source",
          width: "*",
          header: "Source",
          isReadOnly: true,
        },
        {
          binding: "Actions",
          width: "*",
          header: "Actions",
          isReadOnly: true,
        },
      ],

      FiltersDefinition: [
        //Define how filters should look like
        {
          binding: "HexadecimalAdress",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "Value",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "Label",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "Source",
          hasValueFilter: true,
          hasConditionFilter: false,
          values: [
            {
              id: "Fabricant",
              label: "Manufacturer",
            },
            {
              id: "Mobilité",
              label: "Mobility",
            },

            {
              id: "",
              label: "Null",
            },
          ],
        },
      ],

      IsInfiniteScroll: true, //set this to true if you want to see infinite scroll in action
      //data will be populated from the Api but the grid should know what is the desired PageSize,
      //it is used to load automatically call the parent when it's mounted so we don't make multiple calls
      Collection: [
        {
          Label: "Parameter 1",
          Value: "1",
          HexadecimalAdress: "-",
          Source: "Manufacturer",
        },
        {
          Label: "Parameter 2",
          Value: "2",
          HexadecimalAdress: "-",
          Source: "Manufacturer",
        },
      ],
      ExportsHeader: {
        text: "Exports",
        icon: "scf-export",
      },
      // ExportsDataSource: [
      //   { text: "Export as Csv", method: "exportCsv", icon: "scf-csv" },
      //   { text: "Export as Excel", method: "exportExcel", icon: "scf-excel" },
      // ],

      // ExportsEvents: {
      //   exportCsv: this.exportCsv,
      //   exportExcel: this.exportExcel,
      // },
      ExportsDataSourceUnclassifiedParameters: [
        {
          text: "Export as Csv",
          method: "exportCsvUnclassifiedParameters",
          icon: "scf-csv",
        },
        {
          text: "Export as Excel",
          method: "exportExcelUnclassifiedParameters",
          icon: "scf-excel",
        },
      ],
      ExportsEventsUnclassifiedParameters: {
        exportCsvUnclassifiedParameters: this.exportCsvUnclassifiedParameters,
        exportExcelUnclassifiedParameters:
          this.exportExcelUnclassifiedParameters,
      },
      glyphDown: glyphDown,
      FiltersDefinitionPairing: [
        {
          binding: "Id",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "TransmitterId",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "TransmitterExternalId",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "TransmitterRadioMode",
          hasValueFilter: true,
          hasConditionFilter: false,
          values: [
            {
              id: "1G",
              label: computed(() =>
                this.tryGetTranslation("RadioProtocols.1G")
              ),
            },
            {
              id: "2G",
              label: computed(() =>
                this.tryGetTranslation("RadioProtocols.2G")
              ),
            },
            {
              id: "G3BIRDZ",
              label: computed(() =>
                this.tryGetTranslation("RadioProtocols.G3BIRDZ")
              ),
            }
          ],
        },
        {
          binding: "ElectronicIndex",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "MechanicalIndex",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "PulseWeight",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "PairingDate",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "Source",
          hasValueFilter: true,
          hasConditionFilter: false,
          values: [
            {
              id: "Manufacturer",
              label: computed(() =>
                this.getTraductionTransactionSource("Manufacturer")
              ),
            },
            {
              id: "Mobility",
              label: computed(() =>
                this.getTraductionTransactionSource("Mobility")
              ),
            },
            {
              id: "Manual",
              label: computed(() =>
                this.getTraductionTransactionSource("Manual")
              ),
            },
            {
              id: "Assets",
              label: computed(() =>
                this.getTraductionTransactionSource("Assets")
              ),
            },
          ],
        },
      ],
      // ExportsHeaderPairing: { text: "Exports", icon: "scf-export" }, npm i @supervision/vue-components@1.7.16
      ExportsDataSourcePairing: [
        {
          text: "Export as Csv",
          method: "exportCsvPairing",
          icon: "scf-csv",
        },
        {
          text: "Export as Excel",
          method: "exportExcelPairing",
          icon: "scf-excel",
        },
      ],
      ExportsEventsPairing: {
        exportCsvPairing: this.exportCsvPairing,
        exportExcelPairing: this.exportExcelPairing,
      },
      columnsPairing: [
        {
          binding: "Id",
          width: "*",
          header: computed(() =>
            this.$t("pages.DeviceDetails.PairingHistory.columns.Id")
          ),
          visible: false,
        },
        {
          binding: "TransmitterId",
          width: "*",

          header: computed(() =>
            this.$t("pages.DeviceDetails.PairingHistory.columns.TransmitterId")
          ),
          visible: false,
        },
        {
          binding: "TransmitterIdentifier",
          width: "*",

          header: computed(() =>
            this.$t(
              "pages.DeviceDetails.PairingHistory.columns.TransmitterIdentifier"
            )
          ),
        },
        {
          binding: "TransmitterAlternateIdentifier",
          width: "*",

          header: computed(() =>
            this.$t(
              "pages.DeviceDetails.PairingHistory.columns.TransmitterAlternateIdentifier"
            )
          ),
        },
        {
          binding: "TransmitterRadioMode",
          width: "*",

          header: computed(() =>
            this.$t(
              "pages.DeviceDetails.PairingHistory.columns.TransmitterRadioMode"
            )
          ),
        },
        {
          binding: "ElectronicIndex",
          width: "*",
          header: computed(() =>
            this.$t(
              "pages.DeviceDetails.PairingHistory.columns.ElectronicIndex"
            )
          ),
        },
        {
          binding: "MechanicalIndex",
          width: "*",
          header: computed(() =>
            this.$t(
              "pages.DeviceDetails.PairingHistory.columns.MechanicalIndex"
            )
          ),
        },
        {
          binding: "PulseWeight",
          width: "*",
          header: computed(() =>
            this.$t("pages.DeviceDetails.PairingHistory.columns.PulseWeight")
          ),
        },
        {
          binding: "Source",
          width: "*",
          header: "Source",
        },
        {
          binding: "MountingDate",
          width: "*",
          dataType: "Date",
          format: "MM/dd/yyyy",
          header: computed(() =>
            this.$t("pages.DeviceDetails.PairingHistory.columns.PairingDate")
          ),
        },
        {
          header: "Actions",
          width: "*",
        },
      ],
      latestDataPairingState: null,
      latestDataAssociationState: null,
      exportPairingRoot:
        Configs.value("VUE_APP_WEBAPI") + "api/v1/OData/devicePairings/export?",
      exportAssociationRoot:
        Configs.value("VUE_APP_WEBAPI") +
        "api/v1/OData/DeviceAssociations/export?",
      modifiedParams: {},
      errorMessages: this.ErrorMessages,
      additionalData: null,
    };
  },
  methods: {
    tryGetTranslation(key) {
      return typeof this.$tm(key) == "string"
        ? this.$t(key)
        : key;
    },
    GetTraductionForPrincipalCardTitle(value) {
      var traduction = "";
      let x = this.items.filter((e) => e.Key == value);
      if (!utils.isEmpty(x)) {
        let trad;
        trad = x[0].Translations.filter((e) => e.culture == this.culture);
        if (!utils.isEmpty(trad)) {
          traduction = trad[0].value;
        } else {
          traduction = value;
        }
      }
      return traduction;
    },
    GetTraductionForAdditionalCardTitle(value) {
      let traduction = "";
      const sections = this.dataModel && this.dataModel.additionalSections
        ? this.dataModel.additionalSections
        : [];
      const section = sections.find((e) => e.sectionKey == value);
      if (section && !utils.isEmpty(section.translations)) {
        const trad = section.translations.filter(
          (e) => e.culture == this.culture
        );
        if (!utils.isEmpty(trad)) {
          traduction = trad[0].value;
        }
      }
      if (traduction === "") {
        const localeKey = `pages.DeviceDetails.${value}`;
        if (this.translationExists(localeKey)) {
          traduction = this.$t(localeKey);
        } else if (
          value === "UnclassifiedParameters" &&
          this.translationExists("pages.DeviceDetails.AdditionalData")
        ) {
          traduction = this.$t("pages.DeviceDetails.AdditionalData");
        } else {
          traduction = value;
        }
      }
      return traduction;
    },
    ContentHtmlForParams(data) {
      var Output = "";
      data.forEach((e) => {
        console.log(
          this.GetMessageError(
            e.errorCode,
            e.errorMessageValues,
            this.errorMessages
          )
        );
        Output += `${this.GetMessageError(
          e.errorCode,
          e.errorMessageValues,
          this.errorMessages
        )}</br></br>`;
      });
      return Output;
    },
    GetMessageError(errorCode, params, messagesList) {
      if (errorCode !== null && errorCode != "") {
        var message = messagesList.filter(
          (e) => e.key == `ErrorMessage_${errorCode}`
        )[0].value;

        if (params !== null) {
          var paramsArray = params.split(";");
          if (paramsArray.length > 1) {
            for (let i = 0; i < paramsArray.length; i++) {
              if (i == 0) {
                message = message.replace(
                  `{${i}}`,
                  this.translationExists("pages.DeviceDetails." + paramsArray[i])
                    ? this.$t("pages.DeviceDetails." + paramsArray[i])
                    : paramsArray[i]
                );
              } else {
                message = message.replace(`{${i}}`, paramsArray[i]);
              }
            }
          }

          return message;
        }
        return message;
      }
      return "";
    },
    ContentHtmlForModifiedParams() {
      var Output = "";
      Object.keys(this.modifiedParams).forEach((key) => {
        Output =
          Output +
          `${this.translationExists("pages.DeviceDetails." + key)
            ? this.$t("pages.DeviceDetails." + key)
            : key
          }:${this.GetParametersTraductionValue(
            this.modifiedParams[key]
          )}</br>`;
      });
      return `</br>${Output}</br>`;
    },
    UpdateParameters() {
      //TODO
      console.log(this.map(this.modifiedParams));
      Swal.fire({
        title: this.$t(
          "pages.FirmwareAdd.ErrorLabel.DoYouWantToSaveTheChanges"
        ),
        showDenyButton: true,
        html: this.ContentHtmlForModifiedParams(),
        showCancelButton: false,
        confirmButtonText: this.$t("common.save"),
        denyButtonText: this.$t("common.cancel"),
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          //TODO send data and check result
          this.mainService = new MainService(
            this.$jwt.token,
            this.currentScopeView
          );
          this.mainService
            .Sendparams(
              this.type,
              this.identifier,
              this.map(this.modifiedParams)
            )
            .then((response) => {
              //  console.log(response);
              console.log("response : ", response);
              if (
                typeof response.data != "undefined" &&
                response.data != null &&
                response.data != "" &&
                response.data.length != null &&
                response.data.length > 0
              ) {
                //TODO get message code
                Swal.fire({
                  title: "",
                  width: 600,
                  icon: "error",
                  html: this.ContentHtmlForParams(response.data),
                });
              } else {
                Swal.fire({
                  icon: "success",
                  title: this.$t(
                    "pages.FirmwareAdd.ErrorLabel.ParamsModifiedSuccessfuly"
                  ),
                  showConfirmButton: true,
                }).then(() => {
                  this.$router.go();
                });
              }
              //Votre demande de Descente de Firmware est envoyée ParamsModifiedSuccessfuly
            })
            .catch((error) => {
              console.log("error : ", error);
              //TODO swal message une erreur est survenue..
              Swal.fire(this.$t("pages.FirmwareAdd.ErrorLabel.Error"));
            })
            .finally(() => { });
        }
      });
    },
    map(t) {
      return Object.entries(t).map((el) => {
        return {
          Key: el[0],
          Value: el[1],
        };
      });
    },
    translationExists(e) {
      return typeof this.$tm(e) == "string";
    },
    getTraductionTransactionSource: function (e) {
      if (this.translationExists("pages.DeviceImportList.Source." + e + ""))
        return this.$t("pages.DeviceImportList.Source." + e + "");
      return e;
    },
    showdatafromchildAssociatedDevice(e, t) {
      console.log(t);
      e.forEach((e) => {
        this.modifiedParams[e.Key] = e.Value;
      });

      Object.keys(this.modifiedParams).forEach((key) => {
        if (this.modifiedParams[key] === null) {
          delete this.modifiedParams[key];
        }
      });
    },
    gridPairingFilterChanged(data) {
      this.latestDataPairingState = data;
    },
    gridAssociationFilterChanged(data) {
      this.latestDataAssociationState = data;
    },
    gridAssociationHInitialized(flexgrid) {
      this.GridAssociaition = flexgrid;
    },
    exportCsvAssociation() {
      const filter =
        this.latestDataAssociationState !== null &&
          this.latestDataAssociationState !== undefined
          ? this.latestDataAssociationState.filterDefinition
          : "";
      let exportUrl = `${this.exportAssociationRoot}cultureName=${this.$i18n.locale}&exporFormat=csv&deviceId=${this.Id}&type=${this.type}`;
      if (filter != "") {
        exportUrl = `${this.exportAssociationRoot}cultureName=${this.$i18n.locale}&filter=${filter}&exporFormat=csv&deviceId=${this.Id}&type=${this.type}`;
      }

      this.mainService
        .Export(exportUrl, this.gridHeaders)
        .then((response) => {
          console.log(response);
          const type = response.headers["content-type"];
          utils.DownloadBytes(
            `${this.$t("pages.DeviceDetails.Title")}_${this.$t("pages.DeviceDetails.AssociationHistory.ExportName")}(${this.identifier
            })`,
            type,
            "csv",
            response.data
          );
        })
        .catch((error) => {
          console.log(error);
        });
    },
    exportExcelAssociation() {
      const filter =
        this.latestDataAssociationState !== null &&
          this.latestDataAssociationState !== undefined
          ? this.latestDataAssociationState.filterDefinition
          : "";
      let exportUrl = `${this.exportAssociationRoot}cultureName=${this.$i18n.locale}&exporFormat=excel&deviceId=${this.Id}&type=${this.type}`;
      if (filter != "") {
        exportUrl = `${this.exportAssociationRoot}cultureName=${this.$i18n.locale}&filter=${filter}&exporFormat=excel&deviceId=${this.Id}&type=${this.type}`;
      }

      this.mainService
        .Export(exportUrl, this.gridHeaders)
        .then((response) => {
          console.log(response);
          const type = response.headers["content-type"];
          utils.DownloadBytes(
            `${this.$t("pages.DeviceDetails.Title")}_${this.$t("pages.DeviceDetails.AssociationHistory.ExportName")}(${this.identifier
            })`,
            type,
            "xlsx",
            response.data
          );
        })
        .catch((error) => {
          console.log(error);
        });
    },
    exportExcelPairing() {
      const filter =
        this.latestDataPairingState !== null &&
          this.latestDataPairingState !== undefined
          ? this.latestDataPairingState.filterDefinition
          : "";
      let exportUrl = `${this.exportPairingRoot}cultureName=${this.$i18n.locale}&exporFormat=excel&deviceId=${this.Id}`;
      if (filter != "") {
        exportUrl = `${this.exportPairingRoot}cultureName=${this.$i18n.locale}&filter=${filter}&exporFormat=excel&deviceId=${this.Id}`;
      }

      this.mainService
        .Export(exportUrl, this.gridHeaders)
        .then((response) => {
          console.log(response);
          const type = response.headers["content-type"];
          utils.DownloadBytes(
            `${this.$t("pages.DeviceDetails.Title")}_${this.$t("pages.DeviceDetails.PairingHistory.ExportName")}${this.identifier
            }`,
            type,
            "xlsx",
            response.data
          );
        })
        .catch((error) => {
          console.log(error);
        });
    },
    exportCsvPairing() {
      const filter =
        this.latestDataPairingState !== null &&
          this.latestDataPairingState !== undefined
          ? this.latestDataPairingState.filterDefinition
          : "";
      let exportUrl = `${this.exportPairingRoot}cultureName=${this.$i18n.locale}&exporFormat=csv&deviceId=${this.Id}`;
      if (filter != "") {
        exportUrl = `${this.exportPairingRoot}cultureName=${this.$i18n.locale}&filter=${filter}&exporFormat=csv&deviceId=${this.Id}`;
      }

      this.mainService
        .Export(exportUrl, this.gridHeaders)
        .then((response) => {
          console.log(response);
          const type = response.headers["content-type"];
          utils.DownloadBytes(
            `${this.$t("pages.DeviceDetails.Title")}_${this.$t("pages.DeviceDetails.PairingHistory.ExportName")}${this.identifier
            }`,
            type,
            "csv",
            response.data
          );
        })
        .catch((error) => {
          console.log(error);
        });
    },
    exportCsvUnclassifiedParameters() {
      var xls = new XlsExport(this.data.Data);
      xls.exportToCSV(
        `${this.$t("pages.DeviceDetails.UnclassifiedParameters.Title")}(${this.identifier
        })`
      );
    },
    exportExcelUnclassifiedParameters() {
      var xls = new XlsExport(this.data.Data);
      xls.exportToXLS(
        `${this.$t("pages.DeviceDetails.UnclassifiedParameters.Title")}(${this.identifier
        })`
      );
    },
    gridPairingInitialized(flexgrid) {
      this.theGrid = flexgrid;
    },
    formatColumnsPairing: function (s, e) {
      const flex = s;

      if (e.panel == flex.cells) {
        if (flex.rows[e.row].dataItem.name) return;

        switch (flex.columns[e.col].header) {
          case "Actions":
            e.cell.innerHTML =
              Globalize.format(
                '<i class="scf-checkBox-on" style="margin-left: 7px;margin - right: 7px;width: 16px;height: 16px;" title="" ></i>',
                s.rows[e.row].dataItem
              ) +
              Globalize.format(
                '<i class="scf-checkBox-off" style="margin-left: 7px;margin - right: 7px;width: 16px;height: 16px;" title="" ></i>',
                s.rows[e.row].dataItem
              );

            break;
        }

        switch (flex.columns[e.col].binding) {
          case "graph":
            e.cell.innerHTML =
              wijmo.format(
                '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" style="margin-left:10px" class="bi bi-trash" viewBox="0 0 16 16"><path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/><path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/></svg>',
                s.rows[e.row].dataItem
              ) +
              wijmo.format(
                '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" style="margin-left:10px" class="bi bi-arrow-repeat" viewBox="0 0 16 16"><path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z"/><path fill-rule="evenodd" d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z"/></svg>',
                s.rows[e.row].dataItem
              );

            break;

          case "Tile":
            e.cell.innerHTML = wijmo.format(
              '<a href="#">Link</a>',
              s.rows[e.row].dataItem
            );
            break;
          case "MountingDate":
            e.cell.innerText =
              s.rows[e.row].dataItem.MountingDate != null
                ? this.$d(s.rows[e.row].dataItem.MountingDate, {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                  second: "2-digit",
                })
                : "";
            break;
        }
      }
    },
    formatColumns(s, e) {
      const flex = s;

      if (e.panel == flex.cells) {
        switch (flex.columns[e.col].binding) {
          case "Actions":
            e.cell.innerHTML =
              Globalize.format(
                '<i class="scf-checkBox-on" style="margin-left: 7px;margin - right: 7px;width: 16px;height: 16px;" title="" ></i>',
                s.rows[e.row].dataItem
              ) +
              Globalize.format(
                '<i class="scf-checkBox-off" style="margin-left: 7px;margin - right: 7px;width: 16px;height: 16px;" title="" ></i>',
                s.rows[e.row].dataItem
              );
            break;
        }
      }
    },
    CreateArrayKeyValuesFromString(array) {
      let list = [];
      array.forEach((x) =>
        list.push({
          value: x,
          name: this.GetParametersTraductionValue(x),
        })
      );
      return list;
    },
    GetParametersTraductionValue(value) {
      if (utils.isObject(value)) {

        if (this.translationExists("pages.DeviceDetails.ParametersValues." + value.value))
          return this.$t("pages.DeviceDetails.ParametersValues." + value.value);
        else return value.value;
      } else {
        if (this.translationExists("pages.DeviceDetails.ParametersValues." + value))
          return this.$t("pages.DeviceDetails.ParametersValues." + value);
        return value;
      }
    },

    initCountRowsPopup(popup) {
      this.countRowsPopup = popup;
    },
    countRows(popup) {
      this.showCountRowsMessage = this.data.Data.length;
      popup.show(true, () => { });
    },
    GetCustomDetails(t) {
      return Object.entries(t).map((el) => {
        return {
          key: el[1].key,
          value: el[1].Value,
          Source: el[1].Source,
          ReadOnly: el[1].isReadonly,
          AllowedValues:
            el[1].allowedValues != null
              ? this.CreateArrayKeyValuesFromString(
                el[1].allowedValues.split("|")
              )
              : null,
          Traductions: el[1].translations,
        };
      });
    },
  },
  beforeCreate() {
    this.currentScopeView = this.currentScope ?? this.$jwt.scope;
  },
  created() {
    this.currentScopeView = this.currentScope ?? this.$jwt.scope;
  },
  mounted() {
    this.additionalData = this.$parent.additionalData;
  },
};
</script>

<style lang="scss" scoped>
#collapse-example-100 .wj-flexgrid {
  height: 200px !important;
}

.mt-70 {
  margin-top: 70px;
}

.mb-70 {
  margin-bottom: 70px;
}

.card-timeline {
  border-width: 0;
  transition: all 0.2s;
}

.card-timeline {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
}

.card-body {
  flex: 1 1 auto;
  padding: 1.25rem;
}

.vertical-timeline {
  width: 100%;
  position: relative;
  padding: 1.5rem 0 1rem;
}

.vertical-timeline::before {
  content: "";
  position: absolute;
  top: 0;
  left: 67px;
  height: 100%;
  width: 4px;
  background: #e9ecef;
  border-radius: 0.25rem;
}

.vertical-timeline-element {
  position: relative;
  margin: 0 0 1rem;
}

.vertical-timeline--animate .vertical-timeline-element-icon.bounce-in {
  visibility: visible;
  animation: cd-bounce-1 0.8s;
}

.vertical-timeline-element-icon {
  position: absolute;
  top: 0;
  left: 60px;
}

.vertical-timeline-element-icon .badge-dot-xl {
  box-shadow: 0 0 0 5px #fff;
}

.badge-dot-xl {
  width: 18px;
  height: 18px;
  position: relative;
}

.badge:empty {
  display: none;
}

.badge-dot-xl::before {
  content: "";
  width: 10px;
  height: 10px;
  border-radius: 0.25rem;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -5px 0 0 -5px;
  background: #fff;
}

.vertical-timeline-element-content {
  position: relative;
  margin-left: 90px;
  font-size: 0.8rem;
}

.vertical-timeline-element-content .timeline-title {
  font-size: 0.8rem;
  text-transform: uppercase;
  margin: 0 0 0.5rem;
  padding: 2px 0 0;
  font-weight: bold;
}

.vertical-timeline-element-content .vertical-timeline-element-date {
  display: block;
  position: absolute;
  left: -90px;
  top: 0;
  padding-right: 10px;
  text-align: right;
  color: #adb5bd;
  font-size: 0.7619rem;
  white-space: nowrap;
}

.vertical-timeline-element-content:after {
  content: "";
  display: table;
  clear: both;
}

.vertical-timeline-element-icon .badge-dot-xl {
  box-shadow: 0 0 0 5px #fff;
}

.badge-dot-xl {
  width: 18px;
  height: 18px;
  position: relative;
}

.badge-warning {
  color: #212529;
  background-color: #ffc107;
}

.badge {
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.card {
  border: 1px solid #030f40 !important;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
}

.card_header {
  font-family: D-DIN-500 !important;
  padding: 0.5rem 1rem;
  margin-bottom: 0;
  border-radius: 10px 10px 0px 0px !important;
  // background-color: #bbdbfd !important;
  border-bottom: 1px solid #030f40 !important;
}

.card-header {
  // padding: 0.5rem 1rem;
  margin-bottom: 0px;
  border-radius: 10px 10px 0px 0px !important;
  background-color: #bbdbfd !important;
  //border-bottom: 1px solid #030f40 !important;
}

#maincard,
#maincard-header {
  border-bottom: 0px;
  background-color: #f4f6fb !important;
}

.card-header.collapsed {
  .rotateicon {
    transform: rotate(90deg);
    transition: 0.3s transform ease-in-out;
  }

  border-radius: 10px 10px 10px 10px !important;
}

.card-header:not(.collapsed) {
  .rotateicon {
    transition: 0.3s transform ease-in-out;
  }

  border-radius: 0px 10px 0px 0px !important;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: auto;
}

.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  color: #1266f1;
  border-color: #1266f1;
}

.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  color: #1266f1;
  background-color: #fff;
  border-color: #1266f1 #1266f1 #1266f1;
}

.nav-tabs .nav-link {
  border: solid transparent;
  border-width: 0 0 2px;
  border-radius: 0;
  text-transform: uppercase;
  line-height: 1;
  font-weight: 500;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
  padding: 17px 29px 16px;
}

.nav-link {
  display: block;
  padding: 0.5rem 1rem;
  color: #1266f1;
  text-decoration: none;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out;
}

a:hover {
  color: #0e52c1;
}

.nav-link:focus,
.nav-link:hover {
  color: #0e52c1;
}

.title-col-card {
  font-family: D-DIN-700 !important;
  font-style: normal !important;
  color: #6095d6;
  // font-size: 15px !important;
}

.transmitterTitle {
  font-family: D-DIN !important;
  // font-style: normal !important;
  font-size: 16px;
}

.row-padding-bottom-05 {
  padding-bottom: 0.5em;
}

.row-padding-bottom-10 {
  padding-bottom: 1em;
}

.row-padding-bottom-20 {
  padding-bottom: 2em;
}

.row-padding-bottom-30 {
  padding-bottom: 3em;
}

.icon {
  position: relative;
  top: 3px;
  font-size: 20px;
  margin-right: 15px;
}

.header-countRowsPopup {
  font-family: "D-DIN-700" !important;
  background: #bbdbfd !important;
  color: #030f40 !important;
  font-size: 12px !important;
  font-style: normal;
  align-items: center;
  padding: 12px 10px !important;
}

.body-countRowsPopup {
  font-family: "D-DIN" !important;
  color: #030f40 !important;
  font-size: 0.9rem !important;
  font-style: normal;
  align-items: center;
}

.footer-countRowsPopup {
  padding: 0.2rem !important;
}

.button-countRowsPopup {
  background: #eeeeee !important;
  color: #030f40 !important;
  width: 75px;
  height: 25px;
  padding: 1px !important;
  font-family: "D-DIN-700" !important;
  font-size: 12px !important;
  font-style: normal;
  align-items: center;
  border-radius: 5px;
  box-sizing: border-box;
  border: 0.5px solid #d0d8e6;
}

.button-countRowsPopup:focus {
  outline: none !important;
  box-shadow: none !important;
}

.button-countRowsPopup:focus,
.button-countRowsPopup:active {
  outline: none !important;
  box-shadow: none !important;
  border: 1px solid #d0d8e6 !important;
}

.button-countRowsPopup:hover {
  background-color: #deebf8 !important;
  text-decoration: none;
}

.header-countRowsPopup {
  font-family: "D-DIN-700" !important;
  background: #bbdbfd !important;
  color: #030f40 !important;
  font-size: 12px !important;
  font-style: normal;
  align-items: center;
  padding: 12px 10px !important;
}

.body-countRowsPopup {
  font-family: "D-DIN" !important;
  color: #030f40 !important;
  font-size: 0.9rem !important;
  font-style: normal;
  align-items: center;
}

.footer-countRowsPopup {
  padding: 0.2rem !important;
}

.button-countRowsPopup {
  background: #eeeeee !important;
  color: #030f40 !important;
  width: 75px;
  height: 25px;
  padding: 1px !important;
  font-family: "D-DIN-700" !important;
  font-size: 12px !important;
  font-style: normal;
  align-items: center;
  border-radius: 5px;
  box-sizing: border-box;
  border: 0.5px solid #d0d8e6;
}

.button-countRowsPopup:focus {
  outline: none !important;
  box-shadow: none !important;
}

.button-countRowsPopup:focus,
.button-countRowsPopup:active {
  outline: none !important;
  box-shadow: none !important;
  border: 1px solid #d0d8e6 !important;
}

.button-countRowsPopup:hover {
  background-color: #deebf8 !important;
  text-decoration: none;
}

.save-button {
  color: #030f40;
  background-color: #9bcd41;
  border-color: #9bcd41;
  border-radius: 5px;
}

.save-button:hover {
  background-color: rgb(151 219 29);
  color: #fff;
}
</style>

<style lang="css">
@import "../../node_modules/@suez/custom-icons/suez-glyphicons.css";
@import "../../node_modules/bootstrap/dist/css/bootstrap.css";
</style>
